import script from "./message.vue?vue&type=script&setup=true&lang=js"
export * from "./message.vue?vue&type=script&setup=true&lang=js"

import "./message.vue?vue&type=style&index=0&id=50f950f8&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f950f8"]])

export default __exports__